import { Main } from './components';

export default Main;
